/**
 * Shared constants for the Polling section.
 */

// Monthly solar distribution fractions (NL, PVGIS-based)
// Index 0 = January, 11 = December
export const MONTHLY_SOLAR_FRACTIONS = [
  0.031, 0.048, 0.087, 0.115, 0.134,
  0.131, 0.128, 0.112, 0.087, 0.058,
  0.036, 0.028,
]

// Neighbor overlay colors (indigo, pink, sky, amber, emerald)
export const NEIGHBOR_COLORS = [
  'rgba(99, 102, 241, 0.85)',
  'rgba(236, 72, 153, 0.85)',
  'rgba(14, 165, 233, 0.85)',
  'rgba(245, 158, 11, 0.85)',
  'rgba(16, 185, 129, 0.85)',
]

// The meters of one address shown separately ('Per meter'): greens and blues, apart from the neighbors
export const METER_COLORS = [
  'rgba(22, 163, 74, 0.85)',
  'rgba(37, 99, 235, 0.85)',
  'rgba(202, 138, 4, 0.85)',
  'rgba(147, 51, 234, 0.85)',
  'rgba(220, 38, 38, 0.85)',
  'rgba(13, 148, 136, 0.85)',
  'rgba(234, 88, 12, 0.85)',
  'rgba(71, 85, 105, 0.85)',
]

// Maximum number of neighbor meters to compare simultaneously
export const MAX_NEIGHBORS = 5

// Netherlands geographic constants
export const NL_LATITUDE = 52.0
export const NL_LONGITUDE = 5.0

// RSSI signal strength thresholds (dBm)
export const RSSI_THRESHOLDS = {
  good: -55,      // >= -55 = excellent
  moderate: -70,   // -55 to -70 = moderate
  // < -70 = poor
}

// Grid voltage thresholds (V, L1). Used to flag net congestion periods.
// EN 50160 upper limit is 253 V (10-min avg); inverters typically start
// curtailing output near 250 V.
export const VOLTAGE_THRESHOLDS = {
  WARNING: 250,
  CRITICAL: 253,
}

// Panel calculation
export const PANEL_EFFICIENCY_MARGIN = 0.80

// Analysis windows
export const ANALYSIS_DAYS_MAIN = 20
export const ANALYSIS_DAYS_NEIGHBORS = 10
export const MIN_DAYS_FOR_ANALYSIS = 3
